"use client";
import { useTranslations } from "@zapier/i18n";

import {
  Button,
  ModalDialogBody,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogRoot,
  Spacer,
  Text,
} from "@zapier/design-system";
import { useMembers } from "@zapier/client";

export interface TransferOwnershipPromptProps {
  folderName: string;
  folderOwnerId: number;
  assetCount: number;
  isPending?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function TransferOwnershipPrompt({
  folderName,
  folderOwnerId,
  assetCount,
  isPending = false,
  onCancel,
  onConfirm,
}: TransferOwnershipPromptProps) {
  const t = useTranslations("transfer-ownership-prompt");
  const { members } = useMembers({ ids: [folderOwnerId] });
  const ownerName =
    members[String(folderOwnerId)]?.fullName || t("fallbacks.owner-name");

  return (
    <ModalDialogRoot
      isOpen={true}
      isDismissable={!isPending}
      onOpenChange={(isOpen) => {
        if (!isOpen && !isPending) onCancel();
      }}
    >
      <ModalDialogHeader textAlign="start">
        {t("header.transfer-to-owner", { ownerName })}
      </ModalDialogHeader>
      <ModalDialogBody textAlign="start">
        <Text tag="p">
          {t("messages.private-folder", { folderName, ownerName })}
        </Text>
        <Spacer height="1em" />
        <Text tag="p">
          {t("messages.what-happens", { count: assetCount, ownerName })}
        </Text>
      </ModalDialogBody>
      <ModalDialogFooter>
        <Button variant="secondary" isDisabled={isPending} onPress={onCancel}>
          {t("buttons.cancel")}
        </Button>
        <Button isDisabled={isPending} onPress={onConfirm}>
          {t("buttons.move-and-transfer")}
        </Button>
      </ModalDialogFooter>
    </ModalDialogRoot>
  );
}
